const header = document.querySelector(".site-header"),
  headerImg = document.querySelector(".site-header__logo-image"),
  headerInner = document.querySelector(".site-header__mobile-nav"),
  headerImgImg = headerImg.querySelector(".site-header__logo-image-img"),
  headerImgOuter = document.querySelector(".logo-align--center"),
  headerImgImgPRM = headerImg.querySelector(".site-header__logo-image-img-prm");
const isScrolled = (scrollY) => {
  if (scrollY > 50) {
    console.log("scrolled");
    headerImgOuter.classList.add("logo-align--center-scrolled");
    headerImg.classList.add("site-header__logo-image--centered-scrolled");
    header.classList.add("site-header-scrolled");
    headerInner.classList.add("site-header__mobile-nav-scrolled");
    headerImgImg.style.maxWidth = "80px";
    if (headerImgImgPRM != null) {
      headerImgImgPRM.style.maxWidth = "80px";
    }
  } else {
    headerImgOuter.classList.remove("logo-align--center-scrolled");
    headerImg.classList.remove("site-header__logo-image--centered-scrolled");
    header.classList.remove("site-header-scrolled");
    headerInner.classList.remove("site-header__mobile-nav-scrolled");
    headerImgImg.style.maxWidth = "150px";
    if (headerImgImgPRM != null) {
      headerImgImgPRM.style.maxWidth = "150px";
    }
  }
};

const qtyPlus = document.querySelector(".qtyplus"),
  qtyMinus = document.querySelector(".qtyminus"),
  qtyInput = document.querySelector(".product-form__input--quantity");

if (qtyPlus != null && qtyMinus != null && qtyInput != null) {
  qtyPlus.addEventListener("click", (e) => {
    e.preventDefault();

    if (qtyInput.value < 4) {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      return;
    }

    if (qtyInput.value >= 4) {
      qtyInput.value = 4;
      return;
    }

    if (qtyInput.value <= 1) {
      qtyInput.value = 1;
      return;
    }

    if (!isNaN(qtyInput.value)) {
      qtyInput.value = 1;
    }
  });

  qtyMinus.addEventListener("click", (e) => {
    e.preventDefault();

    if (qtyInput.value > 1) {
      qtyInput.value = parseInt(qtyInput.value) - 1;
      return;
    }

    if (qtyInput.value >= 4) {
      qtyInput.value = 4;
      return;
    }

    if (qtyInput.value <= 1) {
      qtyInput.value = 1;
      return;
    }

    if (!isNaN(qtyInput.value)) {
      qtyInput.value = 1;
    }
  });
}

isScrolled(window.scrollY);

window.addEventListener("scroll", () => isScrolled(scrollY));
window.addEventListener("resize", () => isScrolled(scrollY));
